module.exports = __webpack_public_path__ + "static/media/37-9.33b8a3a3.mp3";